import { gsap } from "gsap";
import HeroCollegePattern from "./HeroCollegePattern";

class HeroCollegeTitle {
    constructor(el) {
        this.el = el;
        this.init();
        this.show();
        this.nextLine();
    }

    init() {
        this.createColors();
        this.currentColor = this.hexToRgb(this.colorsArray[0]);
        this.activeLineIndex = -1;

        this.initBackground();
        gsap.set(this.el, {
            y: 40,
        });
        this.initWords();

        this.animationTimeline = gsap.timeline({
            paused: true,
            onComplete: () => this.onAnimationComplete(),
        });
    }

    initBackground() {
        const mainHeroPatternEl = document.getElementById("college-hero-pattern-wrapper");
        if(mainHeroPatternEl) {
            this.heroBackground = new HeroCollegePattern(mainHeroPatternEl, this.currentColor);
        }
    }

    hexToRgb(hex) {
        return {
            r: (hex >> 16) & 255,
            g: (hex >> 8) & 255,
            b: hex & 255
        }
    }

    createColors() {
        this.currentIndex = -1;

        this.colorsArray = [
            0x00A4B1,
            0xA77AD7,
            0xF5564E,
            0xA2C125,
            0xD10077,
            0x93CA15,
            0xFF4D00,
            0xCFD11A,
            0xFF6A1B,
            0x446C5D,
            0x793AFF,
        ];
    }

    initWords() {
        const headingLines = Array.from(this.el.querySelectorAll('.college-heading--line'));

        this.lines = headingLines.map((headingLine, index) => ({
            line: headingLine,
            words: Array.from(headingLine.querySelectorAll('.college-heading--word')).map(headingWord => {
                headingWord
            }),
            chars: Array.from(headingLine.querySelectorAll('.college-heading--char')).map(headingChar => {
                if(index > 0) {
                    gsap.set(headingChar, {
                        opacity: 0,
                        y: 40,
                    });
                }
                return headingChar;
            }),
        }));
    }

    nextLine() {
        const activeLine = this.lines[this.activeLineIndex];
        const nextIndex = this.activeLineIndex >= this.lines.length - 1 ? 0 : this.activeLineIndex + 1;
        const nextLine = this.lines[nextIndex];

        const interpolation = {
            value: 0
        }

        if (activeLine) {
            this.animationTimeline.to(activeLine.chars, {
                opacity: 0,
                y: -40,
                duration: 0.6,
                stagger: 0.02,
                ease: 'power2.out',
                force3D: true,
            }, 0);
        }

        if (nextLine) {
            this.animationTimeline.fromTo(nextLine.chars, {
                opacity: 0,
                y: 40,
            }, {
                opacity: 1,
                y: 0,
                duration: 0.6,
                stagger: 0.02,
                ease: 'power2.out',
                force3D: true,
            }, .2);
        }


        if(this.currentIndex >= 0) {
            this.animationTimeline.to(interpolation, {
                value: 1,
                duration: 1.5,
                onUpdate: () => {
                    const nextIndex = (this.currentIndex + 1) % this.colorsArray.length;
                    const currentColor = this.hexToRgb(this.colorsArray[this.currentIndex]);
                    const nextColor = this.hexToRgb(this.colorsArray[nextIndex]);

                    let r = Math.round(currentColor.r + (nextColor.r - currentColor.r) * interpolation.value);
                    let g = Math.round(currentColor.g + (nextColor.g - currentColor.g) * interpolation.value);
                    let b = Math.round(currentColor.b + (nextColor.b - currentColor.b) * interpolation.value);

                    this.heroBackground.updateColor({ r, g, b });
                },
            }, 0);
        }

        // fill animation timeline to 3s
        this.animationTimeline.to({}, {
            duration: 0.1,
        }, 3);

        this.animationTimeline.play();
    }

    onAnimationComplete() {
        this.activeLineIndex++;
        if (this.activeLineIndex >= this.lines.length) {
            this.activeLineIndex = 0;
        }

        this.animationTimeline.clear();
        this.animationTimeline.progress(0);
        this.currentIndex++;

        if (this.currentIndex >= this.colorsArray.length) {
            this.currentIndex = 0;
        }

        this.nextLine();
    }

    show() {
        gsap.to(this.el, {
            y: 0,
            opacity: 1,
            duration: 1.2,
            delay: 0.3,
            ease: 'power2.out',
        });
    }
}

export default HeroCollegeTitle;
